<form
    [formGroup]="layersVisibilityForm"
    *ngrxLet="{ mapLayers: mapLayers$, isTrackingReceiversSwitchVisible: isTrackingReceiversSwitchVisible$ } as vm"
>
    <h2 class="title">{{ "dtmMapCesium.mapLayersSelector.title" | transloco }}</h2>
    <ng-container *ngFor="let controlName of vm.mapLayers">
        <ng-container
            *ngIf="controlName === MapLayer.SoraBoxes"
            [ngTemplateOutlet]="soraBoxesTemplate"
            [ngTemplateOutletContext]="{ controlName }"
        />
        <ng-container
            *ngIf="controlName === MapLayer.Obstacles"
            [ngTemplateOutlet]="obstaclesTemplate"
            [ngTemplateOutletContext]="{ controlName }"
        />
    </ng-container>

    <div class="map-layer-toggle-container receivers-container" *ngIf="vm.isTrackingReceiversSwitchVisible">
        <div class="header">
            <dtm-ui-icon name="base-station-fill" />
            <div>
                <mat-slide-toggle [formControl]="trackingReceiversSwitchControl" labelPosition="before" class="spread">
                    {{ "dtmMapCesium.mapLayersSelector.trackingReceiversControlLabel" | transloco }}
                </mat-slide-toggle>
            </div>
        </div>
    </div>

    <div
        *ngIf="(vm.mapLayers | invoke: hasAirwaySegmentsLayer) || (vm.mapLayers | invoke: hasAirwaySegmentsConnectionsLayer)"
        class="map-layer-toggle-container airway-container"
    >
        <h3>{{ "dtmMapCesium.mapLayersSelector.airwayHeader" | transloco }}</h3>
        <mat-slide-toggle
            *ngIf="vm.mapLayers | invoke: hasAirwaySegmentsLayer"
            [formControlName]="MapLayer.AirwaySegments"
            labelPosition="before"
            class="spread"
        >
            {{ "dtmMapCesium.mapLayersSelector.airwaySegmentsControlLabel" | transloco }}
        </mat-slide-toggle>
        <mat-slide-toggle
            *ngIf="vm.mapLayers | invoke: hasAirwaySegmentsConnectionsLayer"
            [formControlName]="MapLayer.AirwaySegmentsConnections"
            labelPosition="before"
            class="spread"
        >
            {{ "dtmMapCesium.mapLayersSelector.airwaySegmentConnectionsControlLabel" | transloco }}
        </mat-slide-toggle>
    </div>

    <ng-template let-controlName="controlName" #soraBoxesTemplate>
        <div class="map-layer-toggle-container">
            <div class="header">
                <dtm-ui-icon [name]="controlName | invoke : getIconForMapLayerType" />
                <div>
                    <mat-slide-toggle
                        (change)="turnOffControl($event.checked, MapLayer.Obstacles)"
                        [formControlName]="controlName"
                        labelPosition="before"
                        class="spread"
                    >
                        {{ "dtmMapCesium.mapLayersSelector.soraRiskControlLabel" | transloco : { type: controlName } }}
                    </mat-slide-toggle>
                    <p class="control-description">
                        {{ "dtmMapCesium.mapLayersSelector.soraRiskControlDescription" | transloco : { type: controlName } }}
                    </p>
                </div>
            </div>
            <dtm-map-risk-legend *ngIf="layersVisibilityForm.controls.soraBoxes.value" />
        </div>
    </ng-template>
    <ng-template let-controlName="controlName" #obstaclesTemplate>
        <div class="map-layer-toggle-container">
            <div class="header">
                <dtm-ui-icon [name]="controlName | invoke : getIconForMapLayerType" />
                <div>
                    <mat-slide-toggle
                        (change)="turnOffControl($event.checked, MapLayer.SoraBoxes)"
                        [formControlName]="controlName"
                        labelPosition="before"
                        class="spread"
                    >
                        {{ "dtmMapCesium.mapLayersSelector.obstaclesControlLabel" | transloco }}
                    </mat-slide-toggle>
                    <p class="control-description">
                        {{ "dtmMapCesium.mapLayersSelector.obstaclesControlDescription" | transloco }}
                    </p>
                </div>
            </div>
            <dtm-map-obstacles-dtm-legend *ngIf="layersVisibilityForm.controls.obstacles.value" />
        </div>
    </ng-template>
</form>
